let mapper_options = {
  endpoint: 'divisions',
  recordClass: require('./record'),
  relations: {
    belongsTo: {
      brand: {
        foreignKey: 'brand_id',
        localField: 'brand'
      }
    },
    hasMany: {
      group: {
        foreignKey: 'division_id',
        localField: 'groups'
      },
      smart_group: {
        foreignKey: 'division_id',
        localField: 'smart_groups'
      }
    }
  }
}

module.exports = (store) => {
  store.defineMapper('division', mapper_options)
}
